export default (value) =>{
    let colors=["white","blue","darkgreen","orange","violet","cyan","red","mangenta","maroon"];
    return colors[value];
}